import { Button } from "@material-ui/core";
import React from "react";
import ReactModal from "react-modal";

export const RemoveEventsModal: React.FC<{
  numSelectedEvents: number;
  onClose: () => void;
  onSave: () => void;
}> = ({ numSelectedEvents, onClose, onSave }) => {
  const customStyles = {
    content: {
      zIndex: 10050,
      minHeight: `20vh`,
      maxHeight: 700,
      width: 500,
      top: "auto",
      bottom: "auto",
      right: "auto",
      left: "auto",
      position: "static" as "static",
      display: "flex",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, .8)",
      zIndex: 10000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Confirm Event Deletion"
    >
      <div className="flex flex-col justify-between w-full">
        <div>
          <h2 className="text-xl text-gray-900">Confirm Event Deletion</h2>
        </div>
        <hr />
        <b className="py-5">
          Warning: This operation will delete the event definitions entirely!
        </b>
        If you'd like to stop events from going to a destination, use the "Edit
        Destinations" button instead
        <b className="py-5">
          Are you sure you want to delete {numSelectedEvents} event
          {numSelectedEvents > 0 && "s"}?
        </b>
        <hr />
        <div className="flex space-between mt-5 justify-end">
          <Button onClick={onClose} variant="contained">
            Cancel
          </Button>
          <div className="w-4 flex-shrink-0 flex-grow-0" />
          <Button color="primary" variant="contained" onClick={onSave}>
            Confirm
          </Button>
        </div>
      </div>
    </ReactModal>
  );
};
